var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.943 1.491-8.68 8.453a.2.2 0 0 1-.277 0l-4.929-4.8a.187.187 0 0 1 0-.269L1.255 3.71a.2.2 0 0 1 .276 0l3.593 3.499L12.47.056a.2.2 0 0 1 .276 0l1.198 1.166a.187.187 0 0 1 0 .27Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
export default SvgCheckmark;